import { isValueOf } from '~/core/functions/isValueOf/isValueOf'
import { IPHONE_IMAGE_TYPE_LIST, WEB_ALLOWED_IMAGE_TYPE_LIST } from '~/core/constants'

const IMAGE_TYPES_LIST = [...IPHONE_IMAGE_TYPE_LIST, ...WEB_ALLOWED_IMAGE_TYPE_LIST]

export const isImage = (file: File) => {
  return isValueOf(file.type, IMAGE_TYPES_LIST)
}
